import { render, staticRenderFns } from "./modal-production-write-fine-premium.vue?vue&type=template&id=0df3de4c&scoped=true&"
import script from "./modal-production-write-fine-premium.vue?vue&type=script&lang=js&"
export * from "./modal-production-write-fine-premium.vue?vue&type=script&lang=js&"
import style0 from "./modal-production-write-fine-premium.vue?vue&type=style&index=0&id=0df3de4c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0df3de4c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0df3de4c')) {
      api.createRecord('0df3de4c', component.options)
    } else {
      api.reload('0df3de4c', component.options)
    }
    module.hot.accept("./modal-production-write-fine-premium.vue?vue&type=template&id=0df3de4c&scoped=true&", function () {
      api.rerender('0df3de4c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/calculations/create/additions/modal-production-write-fine-premium.vue"
export default component.exports